<template>
    <v-container max-width="100%" style="margin-top: 2%">
      <!-- Dialog error autorizacao -->
      <template>
        <v-row justify="center">
          <v-dialog v-model="autorizacaoDialog" persistent max-width="500">
            <v-card>
              <v-card-title class="headline">
                <span style="color: #d60000">Mensagem do Sistema</span>
              </v-card-title>
              <v-card-text>
                <span style="color: #d60000">{{ this.mensagemAutorizacaoDialog }}</span>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="red accent-4" class="white--text" @click="logout"
                  >Logout</v-btn
                >
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-row>
      </template>

      <template>
      <v-row justify="center">
        <v-dialog
          v-model="progressoDialog"
          persistent
          max-width="500"
          style="height: 300px; z-index: 90000"
        >
          <v-card>
            <v-card-text>
              <v-row justify="center">
                <h3 style="margin-top: 20px; color: #1565c0">
                  {{ this.mensagemProgressoDialog }}
                </h3>
              </v-row>

              <v-row justify="center">
                <v-progress-circular
                  :size="50"
                  :width="5"
                  color="primary"
                  indeterminate
                  style="margin-top: 10px; margin-bottom: 10px"
                ></v-progress-circular>
              </v-row>
            </v-card-text>
          </v-card>
        </v-dialog>
      </v-row>
    </template>
  
    <v-container class="toolbar__container">
          <v-form ref="form" v-model="formValidado">
            <v-row>
              <v-col cols="12" sm="12" md="3">
                <v-autocomplete
                  v-model="idCercaSelected"
                  :items="cercasSelect"
                  item-text="nome_cerca"
                  item-value="id_cerca"
                  clearable
                  label="Cerca"
                  :rules="[(v) => !!v || 'Selecione uma cerca']"
                ></v-autocomplete>
              </v-col>
              <v-col cols="12" sm="6" md="3">
                <v-datetime-picker
                  label="Data Inicial"
                  v-model="dti"
                  :time-picker-props="timeProps"
                  :text-field-props="textFieldProps"
                  :date-picker-props="dtiProps"
                  time-format="HH:mm:ss"
                  date-format="dd/MM/yyyy"
                  clear-text="Fechar"
                >
                  <template slot="dateIcon">
                    <v-icon>mdi-calendar</v-icon>
                  </template>
                  <template slot="timeIcon">
                    <v-icon>mdi-clock</v-icon>
                  </template>
                </v-datetime-picker>
            </v-col>
            <v-col cols="12" sm="6" md="3">
              <v-datetime-picker
                label="Data Final"
                v-model="dtf"
                :time-picker-props="timeProps"
                :text-field-props="textFieldProps"
                :date-picker-props="dtfProps"
                time-format="HH:mm:ss"
                date-format="dd/MM/yyyy"
                clear-text="Fechar"
              >
                <template slot="dateIcon">
                  <v-icon>mdi-calendar</v-icon>
                </template>
                <template slot="timeIcon">
                  <v-icon>mdi-clock</v-icon>
                </template>
              </v-datetime-picker>
            </v-col>
            <v-col cols="12" sm="4" md="2">
              <v-select
                v-model="filtroTipoViagem"
                :items="tiposViagem"
                item-text="text"
                item-value="value"
                label="Tipo de Viagem"
                clearable
              ></v-select>
            </v-col>
            <v-col cols="12" sm="4" md="1">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    small
                    fab
                    color="primary darken-1"
                    class="white--text"
                    v-bind="attrs"
                    v-on="on"
                    @click="populaRelatorio"
                  >
                    <v-icon>mdi-magnify</v-icon>
                  </v-btn>
                </template>
                <span>Pesquisar</span>
              </v-tooltip>
            </v-col>
            </v-row>
          </v-form>
        </v-container>

        <!-- Totais em Destaque -->
        <v-row v-if="totaisData.length > 0">
          <v-col cols="12">
            <merus-data-table
                :headers="headersTotaisWithProperties"
                :items="totaisData"
                :default-multi-sort="defaultMultiSortTotais"
            >
                <template v-slot:toolbar>
                    <CadastroToolbar
                      title="Totais"
                      :token="token"
                      :items="totaisData"
                      csv-title="totaisgerais"
                      pdf-title="Viagens por Cerca - Totais"
                      :pdf-headers="headersTotais"
                      pdf-filename="totaisgerais"
                      :pdf-subtitle="pdfsubtitle"
                      hide-search
                    />
                </template>
            </merus-data-table>
          </v-col>
        </v-row>

        <!-- Totais por Linha -->
        <v-row v-if="linhasFiltered.length > 0">
          <v-col cols="12">
            <merus-data-table
                :headers="headersLinhasWithProperties"
                :items="linhasFiltered"
                :default-multi-sort="defaultMultiSortLinhas"
            >
                <template v-slot:toolbar>
                    <CadastroToolbar
                      title="Totais por Linha"
                      :token="token"
                      :items="linhasFiltered"
                      csv-title="totaisporlinha"
                      pdf-title="Viagens por Cerca por Linha"
                      :pdf-headers="headersLinhas"
                      pdf-filename="totaisporlinha"
                      :pdf-subtitle="pdfsubtitle"
                      hide-search
                    />
                </template>
            </merus-data-table>
          </v-col>
        </v-row>
  
  <div ref="pdfdiv">
    <merus-data-table
        :headers="headersWithProperties"
        :items="viagensFiltered"
        :loading="loadingViagens"
        :default-multi-sort="defaultMultiSortViagens"
        loading-text="Carregando..."
    >
        <template v-slot:toolbar>
            <CadastroToolbar
              title="Viagens por Cerca"
              :token="token"
              :items="viagensFiltered"
              csv-title="viagenscerca"
              pdf-title="Viagens por Cerca"
              :pdf-headers="headers"
              pdf-filename="viagenscerca"
              :pdf-subtitle="pdfsubtitle"
              hide-search
            />
        </template>

        <template v-slot:item.horario_saida_realizada="{ item }">
          {{ formatDateTime(item.horario_saida_realizada) }}
        </template>

        <template v-slot:item.horario_chegada_realizada="{ item }">
          {{ formatDateTime(item.horario_chegada_realizada) }}
        </template>

        <template v-slot:item.is_inicio="{ item }">
          <v-chip v-if="item.is_inicio == 1" small color="success" text-color="white">
            Início
          </v-chip>
          <v-chip v-else small color="info" text-color="white">
            Fim
          </v-chip>
        </template>

      </merus-data-table>
    </div>
    </v-container>
  </template>
  
  <script>
  import apiController from "@/utils/apiController";
  import MerusDataTable from "./Tables/MerusDataTable.vue";
  import CadastroToolbar from "./Toolbars/CadastroToolbar.vue";
  import DateUtils from "../utils/dateutils";

  export default {
    components: {
    MerusDataTable,
    CadastroToolbar
},
    data: () => ({
      user: null,
      token: null,
      mensagemAutorizacaoDialog: "",
      autorizacaoDialog: false,
      progressoDialog: false,
      mensagemProgressoDialog: "",
      formValidado: false,
      loadingViagens: false,
      headers: [
        { text: "Id Viagem", value: "id_viagem_grid", align: " d-none"},
        { text: "Linha", value: "cod_linha"},
        { text: "Veículo", value: "numero_ordem_veiculo_realizado"},
        { text: "Saída", value: "horario_saida_realizada_extenso"},
        { text: "Chegada", value: "horario_chegada_realizada_extenso"},
        { text: "Sentido", value: "descricao_sentido"},
        { text: "Turno", value: "descricao_turno"},
        { text: "Tipo", value: "is_inicio"},
        { text: "Manual", value: "is_manual_extenso"},
      ],
      headersLinhas: [
        { text: "Código da Linha", value: "cod_linha"},
        { text: "Total de Viagens", value: "total"},
        { text: "Iniciadas", value: "iniciadas"},
        { text: "Finalizadas", value: "finalizadas"},
      ],
      headersTotais: [
        { text: "Descrição", value: "descricao"},
        { text: "Total", value: "total"},
      ],
      textFieldProps: {
        prependInnerIcon: "mdi-calendar",
        rules: [(v) => !!v || "Selecione uma data !"],
      },
      timeProps: {
        useSeconds: true,
      },
      dti: null,
      dtf: null,
      idCercaSelected: null,
      filtroTipoViagem: null,
      tiposViagem: [
        { text: "Todas", value: null },
        { text: "Só Início", value: "inicio" },
        { text: "Só Fim", value: "fim" },
      ],
      cercas: [],
      cercasSelect: [],
      viagens: [],
      viagensFiltered: [],
      dadosRelatorio: {
        viagens: [],
        total: 0,
        total_inicio: 0,
        total_fim: 0,
        linhas: []
      },
      config: null,
      defaultMultiSortTotais: [
        { value: "descricao", options: { text: "Crescente", value: 1 } },
      ],
      defaultMultiSortLinhas: [
        { value: "cod_linha", options: { text: "Crescente", value: 1 } },
      ],
      defaultMultiSortViagens: [
        { value: "cod_linha", options: { text: "Crescente", value: 1 } },
        { value: "horario_saida_realizada", options: { text: "Crescente", value: 1 } },
      ],
    }),
    computed: {
      headersWithProperties() {
        return this.headers.map(h => ({ ...h, filtrable: true, sortable: h.sortable !== false }));
      },
      headersLinhasWithProperties() {
        return this.headersLinhas.map(h => ({ ...h, filtrable: true, sortable: h.sortable !== false }));
      },
      headersTotaisWithProperties() {
        return this.headersTotais.map(h => ({ ...h, filtrable: true, sortable: h.sortable !== false }));
      },
      totaisData() {
        if (this.dadosRelatorio.total === 0) {
          return [];
        }

        let result = [];

        if (this.filtroTipoViagem === "inicio") {
          // Quando filtrado por início, mostra apenas dados relacionados a início
          result = [
            { descricao: "Total de Viagens", total: this.viagensFiltered.length },
            { descricao: "Iniciadas na Cerca", total: this.viagensFiltered.length },
            { descricao: "Total de Linhas", total: this.linhasFiltered.length }
          ];
        } else if (this.filtroTipoViagem === "fim") {
          // Quando filtrado por fim, mostra apenas dados relacionados a fim
          result = [
            { descricao: "Total de Viagens", total: this.viagensFiltered.length },
            { descricao: "Finalizadas na Cerca", total: this.viagensFiltered.length },
            { descricao: "Total de Linhas", total: this.linhasFiltered.length }
          ];
        } else {
          // Sem filtro, mostra todos os dados
          result = [
            { descricao: "Total de Viagens", total: this.dadosRelatorio.total },
            { descricao: "Iniciadas na Cerca", total: this.dadosRelatorio.total_inicio },
            { descricao: "Finalizadas na Cerca", total: this.dadosRelatorio.total_fim },
            { descricao: "Total de Linhas", total: this.dadosRelatorio.linhas.length }
          ];
        }

        return result;
      },
      linhasFiltered() {
        if (!this.filtroTipoViagem) {
          return this.dadosRelatorio.linhas;
        } else if (this.filtroTipoViagem === "inicio") {
          return this.dadosRelatorio.linhas.filter(linha => linha.iniciadas > 0);
        } else if (this.filtroTipoViagem === "fim") {
          return this.dadosRelatorio.linhas.filter(linha => linha.finalizadas > 0);
        }
        return this.dadosRelatorio.linhas;
      },
      pdfsubtitle() {
        let subtitle = "";
        if (this.idCercaSelected) {
          const cerca = this.cercasSelect.find((c) => c.id_cerca === this.idCercaSelected);
          if (cerca) {
            subtitle += `Cerca: ${cerca.nome_cerca} `;
          }
        }
        if (this.dti) {
          subtitle += `| Data Inicial: ${this.formatDateForSubtitle(this.dti)}`;
        }
        if (this.dtf) {
          subtitle += ` | Data Final: ${this.formatDateForSubtitle(this.dtf)}`;
        }
        if (this.filtroTipoViagem) {
          const tipo = this.tiposViagem.find((t) => t.value === this.filtroTipoViagem);
          if (tipo) {
            subtitle += ` | Tipo: ${tipo.text}`;
          }
        }
        return subtitle;
      },
      yesterday() {
        let td = new Date();
        td.setDate(td.getDate() - 1);
        return td.toISOString().substring(0,10);
      },
      dtiProps() {
        return {
          max: this.yesterday
        }
      },
      dtfProps() {
        let min = null;
        if (this.dti) {
          if (typeof this.dti === 'string') {
            min = `${this.dti.substring(6,10)}-${this.dti.substring(3,5)}-${this.dti.substring(0,2)}`;
          } else {
            min = this.dti.toISOString().substring(0,10);
          }
        }
        return {
          min: min
        }
      }
    },
    watch: {
      filtroTipoViagem() {
        this.aplicarFiltro();
      }
    },
    created() {
      this.user = JSON.parse(sessionStorage.getItem("user"));
      this.token = sessionStorage.getItem("api");
      this.initialize();
    },
    mounted() {},
    methods: {
      logout() {
          sessionStorage.removeItem("user");
          sessionStorage.removeItem("api");
          var id = window.setTimeout(function () {}, 0);
          while (id--) {
            window.clearTimeout(id);
          }
          this.$router.push({ path: "/" });
      },
      initialize() {
        this.getConfig();
        this.populaCercas();
      },
      getConfig() {
          apiController.request(apiController.endpoints.getallConfig, {
            silent: true,
            onSuccess: (response) => {
              this.config = response.data[0];
              [this.dti, this.dtf] = DateUtils.setDefaultDateFiltersYesterday(this.config.hora_inicial_dia_operacao);
            },
            onError: (e) => {
              console.log("Response : " + e.message);
              if (e.message == "Request failed with status code 401") {
                this.mensagemAutorizacaoDialog = e.response.data.mensagem;
                this.autorizacaoDialog = true;
              }
            }
          });
        },
      populaCercas() {
        apiController.request(apiController.endpoints.getallCercasativascomtipo, {
          silent: true,
          onSuccess: (response) => {
            this.cercas = response.data;
            this.populaCercasSelect();
          },
          onError: (e) => {
            console.log("ERRO AXIOS");
            console.log(e.message);
            if (e.message == "Request failed with status code 401") {
              this.mensagemAutorizacaoDialog =
                "Acesso não autorizado. Token de acesso inválido ou expirado !";
              this.autorizacaoDialog = true;
            }
          }
        });
      },
      populaCercasSelect() {
        this.cercasSelect = this.cercas;
      },
      populaViagens() {
        if (!this.idCercaSelected || !this.dti || !this.dtf) {
          return;
        }

        this.loadingViagens = true;
        let dataInicial = DateUtils.getDateSQLFormatted(this.dti);
        let dataFinal = DateUtils.getDateSQLFormatted(this.dtf);
       
        let temp = {
          idcerca: this.idCercaSelected,
          dti: dataInicial,
          dtf: dataFinal
        }

        apiController.request(apiController.endpoints.getViagenscercainiciofim, {
          data: temp,
          silent: true,
          onSuccess: (response) => {
            this.dadosRelatorio = response.data;
            console.log(this.dadosRelatorio);
            this.viagens = response.data.viagens;
            this.aplicarFiltro();
            this.loadingViagens = false;
          },
          onError: (e) => {
            this.loadingViagens = false;
            console.log("ERRO AXIOS");
            console.log(e.message);
            if (e.message == "Request failed with status code 401") {
              this.mensagemAutorizacaoDialog =
                "Acesso não autorizado. Token de acesso inválido ou expirado !";
              this.autorizacaoDialog = true;
            }
          }
        });

      },
      aplicarFiltro() {
        if (!this.filtroTipoViagem) {
          this.viagensFiltered = this.viagens;
        } else if (this.filtroTipoViagem === "inicio") {
          this.viagensFiltered = this.viagens.filter(v => v.is_inicio == 1);
        } else if (this.filtroTipoViagem === "fim") {
          this.viagensFiltered = this.viagens.filter(v => v.is_fim == 1);
        }
      },
      populaRelatorio() {
        this.$refs.form.validate();
        if (this.formValidado) {
          this.viagens = [];
          this.viagensFiltered = [];
          this.dadosRelatorio = {
            viagens: [],
            total: 0,
            total_inicio: 0,
            total_fim: 0,
            linhas: []
          };
          this.populaViagens();
          this.$nextTick(() => { this.$refs.form.resetValidation(); });
        }
      },
      formatDateTime(dateTime) {
        if (!dateTime) return "";
        try {
          const date = new Date(dateTime);
          return date.toLocaleString('pt-BR', {
            day: '2-digit',
            month: '2-digit',
            year: 'numeric',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit'
          });
        } catch (e) {
          return dateTime;
        }
      },
      formatDateForSubtitle(date) {
        if (!date) return "";
        if (date instanceof Date) {
          return date.toLocaleDateString('pt-BR');
        }
        return date;
      }
    },
  };
  </script>
 